module.exports = __webpack_public_path__ + "img/ico-notif-payment.65a4d77a.svg";